module.exports = __webpack_public_path__ + "static/Tanmai-de38a85a7cbcb8ca972373e0a3d9b617.jpg";